// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import Maps__AutocompleteController from "./maps/autocomplete_controller"
application.register("maps--autocomplete", Maps__AutocompleteController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import FormImagePreviewController from "./form/image_preview_controller"
application.register("form--image-preview", FormImagePreviewController)

import FormRegistrationController from "./form/registration_controller"
application.register("form--registration", FormRegistrationController)

import FormEmailValidationController from "./form/email_validation_controller"
application.register("form--email-validation", FormEmailValidationController)

import EventTeamNameController from "./event_team/name_controller"
application.register("event-team--name", EventTeamNameController)

import InvitationFormController from "./invitation/form_controller"
application.register("invitation--form", InvitationFormController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import Dialog from '@stimulus-components/dialog'
application.register('dialog', Dialog)
